export { HotspotsComponent } from './hotspots'
export { HotspotsFloatElement } from './hotspots-float-element'
